import { useMemo } from "react";

import { useSelector } from "react-redux";

import { useTranslation } from "pro-features/components/WithTranslation";
import {
    ACCOUNTS_MANDATORY_FIELDS,
    CONTACTS_ENRICHMENT_MANDATORY_FIELDS,
} from "app/pages/sales-intelligence/sub-modules/management/constants";
import { selectHsSettings } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspot/exportSelectors";

import CreateJobButton from "../../components/CreateJobButton/CreateJobButton";
import EditExportPreferencesButton from "../../components/EditExportPreferencesButton/EditExportPreferencesButton";
import SectionEmptyState from "../../components/SectionEmptyState/SectionEmptyState";

const HubsportEnrichmentEmptyState = ({
    onEditMapping,
    isMappingLoading,
    onClickAddJob,
    isDisabledAddButton,
}: {
    onEditMapping: () => void;
    isMappingLoading: boolean;
    onClickAddJob: () => void;
    isDisabledAddButton: boolean;
}) => {
    const translate = useTranslation();

    const settings = useSelector(selectHsSettings);

    const isMappingDefault = useMemo(
        () =>
            settings.accounts.filter((setting) => setting.forEnrichment).length <= ACCOUNTS_MANDATORY_FIELDS.length &&
            settings.contacts.filter((setting) => setting.forEnrichment).length <=
                CONTACTS_ENRICHMENT_MANDATORY_FIELDS.length,
        [settings],
    );

    return (
        <SectionEmptyState
            iconName="hubspot-cloud-revenue"
            title={translate("si.crm-enrichment.hs.empty-state.title")}
            subtitle={
                isMappingDefault
                    ? translate("si.crm-enrichment.hs.empty-state.subtitle.mapping-default")
                    : translate("si.crm-enrichment.hs.empty-state.subtitle")
            }
        >
            {isMappingDefault ? (
                <EditExportPreferencesButton
                    isDisabled={isMappingLoading}
                    onClick={onEditMapping}
                />
            ) : null}

            <CreateJobButton
                isDisabled={isDisabledAddButton}
                onClick={onClickAddJob}
            />
        </SectionEmptyState>
    );
};

export default HubsportEnrichmentEmptyState;
